'use client';

import { useEffect, useRef } from 'react';
import { useUser } from '@clerk/nextjs';

const useAuthEvents = () => {
  const { isSignedIn, isLoaded } = useUser();
  const previousSignedIn = useRef<boolean | null>(null);

  useEffect(() => {
    if (!isLoaded) return;

    // Detect sign-in event (transition from not signed in to signed in)
    if (isSignedIn && previousSignedIn.current === false) {
      localStorage.removeItem('alfa-quota-alert-dismissed');
    }

    // Update the previous state
    previousSignedIn.current = isSignedIn;
  }, [isSignedIn, isLoaded]);
};

export default useAuthEvents;